// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_BuscaStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos/buscaStatus
 *
 * Returns a map of status codes to translated display names. The wire shape
 * is `dados: { status: { '1': 'Open', '2': 'Closed', ... } }` — a flat
 * `Record<string, string>` enum map, NOT a list of typed rows. A Row class
 * would mis-shape the response (turning the map into a list).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Compromissos_BuscaStatusResponseDados {
status: Record<string, string>
}

export type Compromissos_BuscaStatusResponse = ApiResponse<Compromissos_BuscaStatusResponseDados>;

registerResponseContract('Compromissos_BuscaStatusResponse', {
  status: { type: 'object',  required: true },
})
